<template>
  <section class="events-slider-card">
    <router-link tag="a" :to="$store.getters['main/getSingleUrl'](data)" class="event-info">
      <!-- <div class="img-box">
					<picture>
						<source
							class="img-absolute scale"
							media="(max-width: 767px)"
							:srcset="_.get(data, 'images[0].devices.mobile')"
						/>
						<source
							class="img-absolute scale"
							media="(max-width: 1023px)"
							:srcset="_.get(data, 'images[0].devices.tablet')"
						/>
						<img
							class="img-absolute scale"
							:src="_.get(data, 'images[0].devices.desktop')"
							:alt="_.get(data, 'images[0].title.title')"
						/>
					</picture>
				</div> -->
      <h3 class="font-21 text-overflow-hidden-2">
        {{ data.title }}
      </h3>
      <!-- <div
        class="text-overflow-hidden-2-envent event-text"
        v-html="data[`content_${$store.state.main.locale}`]"
      ></div> -->
      <div class="publish-date">{{ $fn.tr('Published:') }} {{ published }}</div>
    </router-link>
  </section>
</template>
<script>
import moment from 'moment';
export default {
  props: ['data'],
  computed: {
    published() {
      return moment(_.get(this.data, 'date')).format('DD/M/YYYY');
    },
  },
};
</script>
<style lang="scss">
.events-slider-card {
  height: 100%;
  .event-info {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .img-box {
      position: relative;
      padding-top: 53%;
      .img-absolute {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    h3 {
      margin-bottom: 17px;
      line-height: 28px;
      color: var(--bonus-txt);
      text-decoration: underline;
      text-decoration-color: var(--bonus-txt);
      @media (max-width: 1365px) {
        margin: 21px 0;
        line-height: 31px;
        font-size: 21px;
      }
      @media (max-width: 1023px) {
        margin: 34px 0;
        line-height: 41px;
        font-size: 34px;
      }
      @media (max-width: 767px) {
        margin: 21px 0;
        line-height: 31px;
        font-size: 21px;
      }
    }
    .event-text {
      color: var(--bonus-txt);
      text-decoration: underline;
      text-decoration-color: var(--bonus-txt);
      line-height: 24px;
      max-height: 48px;
      overflow: hidden;
      p {
        font-size: 16px !important;
      }
    }
    .publish-date {
      margin-top: 10px;
      color: #db504a;
      overflow: hidden;
      line-height: 24px;
      padding-bottom: 34px;
      font-size: 16px !important;
      border-bottom: 1px solid #db504a;
    }
  }
}
</style>
